import api from "@/config/apiConfig"

class ScheduledMessagesController {

  async create(data) {
    try {
      let response;
      if (data.file) {
        const formData = new FormData();
        formData.append('body', data.body || '');
        formData.append('scheduledAt', data.scheduledAt);
        formData.append('ticketId', data.ticketId);
        formData.append('mediaType', data.mediaType || 'text');
        formData.append('file', data.file);
        
        response = await api.post(`scheduled-messages`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        response = await api.post(`scheduled-messages`, data);
      }
      return response.data;
    } catch (error) {
      console.error("Erro no ScheduledMessagesController.create: ", error);
      throw error;
    }
  }

  async listByTicket(ticketId) {
    try {
      const response = await api.get(`scheduled-messages/ticket/${ticketId}`);
      return response.data;
    } catch (error) {
      console.error("Erro no ScheduledMessagesController.listByTicket: ", error);
      throw error;
    }
  }

  async cancel(id) {
    try {
      const response = await api.delete(`scheduled-messages/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erro no ScheduledMessagesController.cancel: ", error);
      throw error;
    }
  }
}

export default new ScheduledMessagesController();
